export const FETCH_SUMMARY_REQUEST = 'FETCH_SUMMARY_REQUEST'
export const FETCH_SUMMARY_SUCCESS = 'FETCH_SUMMARY_SUCCESS'
export const FETCH_SUMMARY_FAILED = 'FETCH_SUMMARY_FAILED'
export const FETCH_SUMMARY_DETAIL_REQUEST = 'FETCH_SUMMARY_DETAIL_REQUEST'
export const FETCH_SUMMARY_DETAIL_SUCCESS = 'FETCH_SUMMARY_DETAIL_SUCCESS'
export const FETCH_SUMMARY_DETAIL_FAILED = 'FETCH_SUMMARY_DETAIL_FAILED'
export const FETCH_AVAILABLE_INVOICE_REQUEST = 'FETCH_AVAILABLE_INVOICE_REQUEST'
export const FETCH_AVAILABLE_INVOICE_SUCCESS = 'FETCH_AVAILABLE_INVOICE_SUCCESS'
export const FETCH_AVAILABLE_INVOICE_FAILED = 'FETCH_AVAILABLE_INVOICE_FAILED'
export const DOWNLOAD_SIMPLE_EXCEL_REQUEST = 'DOWNLOAD_SIMPLE_EXCEL_REQUEST'
export const DOWNLOAD_SIMPLE_EXCEL_SUCCESS = 'DOWNLOAD_SIMPLE_EXCEL_SUCCESS'
export const DOWNLOAD_SIMPLE_EXCEL_FAILED = 'DOWNLOAD_SIMPLE_EXCEL_FAILED'
export const DOWNLOAD_DETAIL_CSV_REQUEST = 'DOWNLOAD_DETAIL_CSV_REQUEST'
export const DOWNLOAD_DETAIL_CSV_SUCCESS = 'DOWNLOAD_DETAIL_CSV_SUCCESS'
export const DOWNLOAD_DETAIL_CSV_FAILED = 'DOWNLOAD_DETAIL_CSV_FAILED'
export const DOWNLOAD_INVOICE_PDF_REQUEST = 'DOWNLOAD_INVOICE_PDF_REQUEST'
export const DOWNLOAD_INVOICE_PDF_SUCCESS = 'DOWNLOAD_INVOICE_PDF_SUCCESS'
export const DOWNLOAD_INVOICE_PDF_FAILED = 'DOWNLOAD_INVOICE_PDF_FAILED'
